module.exports = __webpack_public_path__ + "img/Misie..eaf322b1.svg";